<template>
    <div>        
        <ul role="list" class="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 ">        
            <li
                v-for="row in dataRows.rows"
                class="cursor-pointer col-span-1 flex flex-col  bg-white rounded-md  divide-y divide-gray-200 border-2 border-gray-100"
                :class="(inative(row.status)) ? (searchSelected(row.id)) ? 'isSelected' : 'bg-gray-100' : (searchSelected(row.id)) ? 'isSelected' : 'hover:border-indigo-600 '"
                :key="row.id"
                @click="show($event, row)">
                <div class="relative flex-1 flex flex-col p-4 flex-shrink-0 rounded-md min-h-[110px]"  >
                    <div v-if=(row.new) class="absolute">
                        <span class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-cyan-800 text-white">
                            New
                        </span>
                    </div>     

                    <div v-if="row.color" class="flex justify-between -mt-2 mb-2">
                        <div :class="row.color" class="h-2 w-5 rounded-full"/>
                        <h5 v-if="row.privacy" class="text-[10px] font-light">{{row.privacy}}</h5>
                    </div>

                    
                    <h3 class="text-gray-900 text-sm font-medium">{{ row.name }}</h3>                    
                    <h5 v-if="row.description" class="text-gray-900 text-xs font-light">{{ row.description }}</h5>
                    <div class="flex-shrink-0 sm:mt-0 flex pt-2 -mb-1" v-if="row.users">
                        <div v-for="(user,key) in row.users" :key="key">
                            <Avatar  :avatar="user.avatar" size='sm' class="inline-block h-8 w-8 rounded-full ring-2 ring-white"   :alt="user.name" v-if="key < 5" />    
                        </div>
                    </div>
                </div>
            </li>

            <slot />
        </ul>
    </div>
</template>

<script>


export default {
    name: "ListBigCard",
    props: {
        dataRows: {
            type: Object,
            required: false
        },
        selected: {
            type: Array,
            required: false
        },
        show: {
            type: Function,
            required: false
        },
    },
    data(){

        return {

        }

    },
    emits: ['open:item'],
    
    components: {
        
    },
    methods: {
        showData(){
            try{
                if(this.dataRows.rows.length){
                    return true;
                }
                return false 
            } catch(e){
                return false;
            }
            
        },
        inative(status){
            if(status == 'inative'){
                return true;
            }
            return false;
        },
        processAttribute(key, attribute) {
            return Attributs.process(key, attribute); 
        },
        searchSelected(id) {        
            return this.selected.indexOf(id) > -1;
        },
    },
    created() {


    },
    
}


</script>

<style scoped>
.isSelected {
    @apply bg-indigo-50;
}

</style>